import HeaderIcon from 'components/header/headerIcon/headerIcon.module';
import { CSS_COLORS } from 'consts/consts';
import { HEADER_TYPE } from 'consts/enum';
import { left } from 'icons/left';
import './headerCard.scss';

export const HeaderCardTemplate = (model) => {
	const { alignment, description, title, isLaunchScreenEnabled, headerType } = model;
	const botIcon = new HeaderIcon({
		headerType,
	});

	const backToLaunchScreen = isLaunchScreenEnabled
		? /* html */
		  `<div tabindex="0" 
		  	onkeydown="ENGT_CHAT.onEnterPress()"
		  	onclick="ENGT_CHAT.onHeaderBackClick(this);" class="engt-header-back-to-launch engt-tab-selectable">${left(
				CSS_COLORS.THEME_TEXT_COLOR
			)}</div>`
		: '';

	const descriptionTag =
		description && typeof description === 'string'
			? /* html */
			  `<span class="engt-header-info-description">${description}</span>`
			: '';

	const aligmentClass = alignment === 'LEFT' ? 'engt-align-left' : 'engt-align-center';

	const getTitleArea =
		headerType === HEADER_TYPE.TEXT_WITH_IMAGE
			? `
				<span id="engtChatScreenHeader" class="engt-header-info-title">${title}</span>
				${descriptionTag}
			`
			: botIcon.render();

	/* html */
	const html = `
		<div class="engt-header-img-section ${aligmentClass}">
			${backToLaunchScreen}
			${headerType === HEADER_TYPE.TEXT_WITH_IMAGE ? botIcon.render() : ''}
		</div>
		<div class="engt-header-info ${aligmentClass}" >
			${getTitleArea}
		</div>
    `;

	return html;
};
